import useApiRequest from 'api/useApiRequest';
import { fetchCrmEmail, fetchCrmEmails, type CrmEmailListItem } from 'api/services/crmEmailService';

export type { CrmEmailListItem };

const useCrmEmails = () => {
  const { request } = useApiRequest();

  const getDraftEmails = async ({ signal }: { signal?: AbortSignal } = {}): Promise<CrmEmailListItem[]> => {
    const { data } = await fetchCrmEmails(request, { signal });
    return (data?.results ?? []).filter((email: CrmEmailListItem) => email.status === 'Draft');
  };

  const getCrmEmail = async (params: Parameters<typeof fetchCrmEmail>[1]) => {
    const { data } = await fetchCrmEmail(request, params);
    return data;
  };

  return { getDraftEmails, getCrmEmail };
};

export default useCrmEmails;
